// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

export const registerUser = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/users/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    // Check for specific status codes in the response
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: data.result };
    }else if(data.statusCode===1001){
      return { success: 'Added Successfully' };
    }else{
      return { error: 'Fail' };
    }
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};


export const fetchUserDataByClient = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/users/getusersbyclientid/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching countries:', error);
    alert('Error fetching countries:'+ error);
    throw error;
  }
};

export const fetchUserDataById = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/users/getuser/${userId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data.result; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const updateUser = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/users/updateuser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();// Check for specific status codes in the response
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: data.result };
    }else if(data.statusCode===1001){
      return { success: 'Updated Successfully' };
    }else if(data.statusCode===1003){
        return { error: data.result };
    }
    else if(data.statusCode===1004){
        return { error: data.result };
    }else{
      return { error: 'Fail' };
    }
    alert(data);
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};


export const changePassword = async (req) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/users/changepassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(req),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();// Check for specific status codes in the response
    if(data.statusCode===1001){
      return { success: 'Updated Successfully' };
    }else if(data.statusCode===1003){
        return { error: data.result };
    }
    else if(data.statusCode===1004){
        return { error: data.result };
    }else{
      return { error: 'Fail' };
    }
    alert(data);
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

